import React from "react";
import { Col, Row,Button,Modal } from "react-bootstrap";
import StepZilla from "react-stepzilla";
import ProductInfo from "./ProductInfo";
import PriceInfo from "./PriceInfo";
import $ from "jquery";
import { newSubscriptionAction, uploadImageAction,deleteImageAction,updateSubscriptionAction } from './../../../actions/SubscriptionAction';
import { connect } from "react-redux";
import * as code from './../../../config/Constants';
import { toastMessage } from './../../Common/Common';
import { Link } from "react-router-dom";
import { Close, HelpOutline } from "@material-ui/icons";


class AddSubscription extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      product_name: "",
      product_description: "",
      statement_descriptor: "",
      transactionCounter: "",
      templateCounter: "",
      emailSentCounter: "",
      textSentCounter: "",
      uploadDocumentSize: "",
      formError: '',
      priceInformation: [],
      fileName: '',
      subscriptionData:{},
      acceptedFiles:[],
      isShowPrompt:false
    };
  }
  getSubscriptionData() {
    return this.state;
  }
  /**
 * @desc update subscription data with field name 
 * @param {*} field 
 * @param {*} value 
 */
  updateSubscriptionData(field, value) {
    var fieldState = {};
    fieldState[field] = value;
    this.setState(fieldState);
  }
  /**
* @desc get step number and performed actions
* @param {*} step 
*/
  getLastStep(step) {
    if (step === 0) {
      $(".saveBtn").html("Next");
    }
    if (step === 1) {
    
        $(".saveBtn").html("Submit");   
    }
    if (step === 2) {
      if(this.state.priceInformation.length > 0){
      this.isShowPrompt();}
      else{
        this.submitAction()
      }
    }
  }
  submitAction() {
    let data = {
      name: this.state.product_name,
      description: this.state.product_description,
      statementDescriptor: this.state.statement_descriptor,
      fileName: this.state.acceptedFiles.length > 0 ? this.state.acceptedFiles[0].name : '',
      metaData: {
        transactionCounter: this.state.transactionCounter,
        templateCounter: this.state.templateCounter,
        emailSentCounter: this.state.emailSentCounter,
        textSentCounter: this.state.textSentCounter,
        uploadDocumentSize: this.state.uploadDocumentSize
      },
      price: this.state.priceInformation,
    };
   
    this.addSubscription(data);
  }
  addSubscription(data) {

    this.props.newSubscriptionAction(data).then(res => {
      this.props.history.push("/subscription");
      if (res.status === code.OK) {
        toastMessage(code.SUCCESS, "Subscription added");
        this.setState({ showLoader: false });      
      } else {
        toastMessage(code.ERROR, res.data);
        this.setState({ showLoader: false });
      }

    })

  }
 
  okPrompt() {
    this.setState({ isShowPrompt: false,showLoader: true });
    this.submitAction();
  }
  isShowPrompt() {
    this.setState({ isShowPrompt: !this.state.isShowPrompt });
  }
  render() {
    const steps = [
      {
        name: "Product Information",
        component: (
          <ProductInfo
            updateSubscriptionData={(k, v) => {
              this.updateSubscriptionData(k, v);
            }}
            getSubscriptionData={() => this.getSubscriptionData()}
          />
        )
      },
      {
        name: "Price Information",
        component: (
          <PriceInfo
            updateSubscriptionData={(k, v) => {
              this.updateSubscriptionData(k, v);
            }}
            getSubscriptionData={() => this.getSubscriptionData()}
          />
        )
      }
    ];

    if (this.state.showLoader) {
      return (
        <div className="page-loader fixed">
          <div className="page-loader-inner">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="step-progress transaction-create">
          <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
            <Col xs={12} sm={3}>
              <h4 className="title-med mt-0 pt-1">Add New Subscription</h4>
            </Col>

            <Col xs={12} sm={6}></Col>

            <Col xs={12} sm={3} align="right" className="transaction-close">
              <Link to="/subscription" className="nav-link p-0 color-black">
                <Close
                  style={{ stroke: "#fff", height: "40px", width: "40px" }}
                />
              </Link>
            </Col>

          </Row>
          <div className="multi-step multi-step-admin">
            <StepZilla
              showNavigation={true}
              steps={steps}
              backButtonCls="btn btn-sm btn-primary btn-blue btn-outlined w-140 mr-3"
              nextButtonCls={"btn btn-sm btn-primary btn-blue w-140 saveBtn"}
              backButtonText="Back"
              onStepChange={step => this.getLastStep(step)}
              hocValidationAppliedTo={[0]}
              preventEnterSubmission={true}
            />
          </div>
          <Modal
            show={this.state.isShowPrompt}
            dialogClassName="modal-90w"
            aria-labelledby="example-custom-modal-styling-title"
            className="modal-med modal-400 modal-delete"
            centered
            backdrop={false}
          >
            <Modal.Body className="pb-0 text-center">
              <HelpOutline />
              <p>Once you setup subscription you cannot edit/delete price tier.Are you sure you want to continue?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary"
                className="btn-blue btn-outlined w-140"
                onClick={() => {
                  this.isShowPrompt();
                }}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                className="btn-blue w-140"
                onClick={() => {
                  this.okPrompt();
                }}
              >
                Yes
              </Button>
            </Modal.Footer>
          </Modal>

        </div>

      );
    }
  }
}
const mapStateToProps = state => {
  return {
    subscriptionData: state.reducer.subscriptionData,
    isImageDeleted: state.reducer.isImageDeleted,

  };
};

export default connect(mapStateToProps, { newSubscriptionAction, uploadImageAction,deleteImageAction,updateSubscriptionAction })(AddSubscription)